import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, toDisplayString as _toDisplayString, vModelDynamic as _vModelDynamic, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6dd4bc04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "login-inner" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reset-password-title" }, "找回密碼", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reset-password-text" }, "我們將發送驗證碼作為找回密碼之用，請確保所輸入的電郵地址正確。", -1))
const _hoisted_6 = { class: "login-form" }
const _hoisted_7 = { class: "login-form-item" }
const _hoisted_8 = { class: "login-form-left" }
const _hoisted_9 = ["placeholder"]
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "login-form-item" }
const _hoisted_12 = { class: "login-form-left" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = ["src"]
const _hoisted_15 = ["src"]
const _hoisted_16 = { class: "login-inner" }
const _hoisted_17 = ["href"]
const _hoisted_18 = ["src"]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "reset-password-title" }, "修改密碼", -1))
const _hoisted_20 = { class: "login-form" }
const _hoisted_21 = { class: "login-form-item" }
const _hoisted_22 = { class: "login-form-left" }
const _hoisted_23 = ["placeholder"]
const _hoisted_24 = ["src"]
const _hoisted_25 = ["src"]
const _hoisted_26 = { class: "login-form-item" }
const _hoisted_27 = { class: "login-form-left" }
const _hoisted_28 = ["type", "placeholder"]
const _hoisted_29 = ["src"]
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "login-form-item" }
const _hoisted_32 = { class: "login-form-left" }
const _hoisted_33 = ["type", "placeholder"]
const _hoisted_34 = ["src"]
const _hoisted_35 = ["src"]

import { reactive,getCurrentInstance } from "vue";
import ResetPassword from "@/js/api/model/resetPassword/index.js"
import pullRefresh from "@/components/pullRefresh/index.vue";
import pullRefreshJs from "@/components/pullRefresh/index.js"//pullRefresh組件列表懶加載

export default {
  __name: 'index',
  setup(__props) {

const { proxy } = getCurrentInstance()
const Util = proxy.$Util
const Element = proxy.$Element
const CONFIG = proxy.$CONFIG
const Router = proxy.$Router
const data = reactive({
  form:{
    email:"",
    captcha:""
  },
  label:{
    email:{
      rules:[
        {
          name:"email",
          text:msg['jsLang.EmailFail']
        }
      ],
      name:"請輸入電郵地址"
    },
    captcha:{
      rules:[
        {
          name:"request",
          text:msg['jsLang.codeNotBlank']
        }
      ],
      name:"請輸入驗證碼"
    }
  },
  resetPasswordForm:{
    token:"",
    password:"",
    passwords:""
  },
  resetPasswordLabel:{
    token:{
      name:"請輸入電郵驗證碼",
      rules:[
        {
          name:"request",
          text:msg['jsLang.emailCodeNotBlank']
        }
      ],
      tip:""
    },
    password:{
      name:"請輸入密碼",
      rules:[
        {
          name:"lenLimit",
          min:6,
          max:18,
          text:msg['jsLang.passwordLength']
        }
      ],
      tip:"",
      showPassword:false,
    },
    passwords:{
      name:"再次輸入密碼",
      rules:[
        {
          name:"sameValue",
          key:"password",
          text:msg['jsLang.passwordInconsistency']
        },
        {
          name:"lenLimit",
          min:6,
          max:18,
          text:msg['jsLang.passwordLength']
        }
      ],
      tip:"",
      showPassword: false,
    },
  },
  codeUrl:`${proxy.$CONFIG.BASE_URL}ucs/api/v1/captchas?${Math.random()}`,
  lType:"0",//'0'為找回密碼，'1'為修改密碼
  isRequest:false,
  isRegisterRequest:false,
  isVcodeRequest:false,
  vcodeText:'獲取',
  loginHeight:"",
})

const reloadCode = ()=>{
  data.codeUrl = `${proxy.$CONFIG.BASE_URL}ucs/api/v1/captchas?${Math.random()}`
}
const uFormInputBlur = Util.formInputBlur
const formInputBlur = ({form,label,key})=>{
  setTimeout(()=>{
    data[label][key].tip = uFormInputBlur({form:data[form],label:data[label],key})
  },500)
}
const resetPasswordsFocus = ()=>{
  /*data.resetPasswordsTip = ""
  data.resetPasswordsTipIconShow=false
  data.resetPasswordTipIconShow=true
  let key = "password"
  let res = verifyFormType({form:data.resetPasswordForm,label:data.resetPasswordLabel,key,type:"lenLimit"})
  if(!res.bool){//res.ruleIndex
    data.resetPasswordTip = data.resetPasswordLabel[key].rules[res.ruleIndex].text
    data.resetPasswordCheck= false
    return
  }
  data.resetPasswordCheck=true*/
}
/*const resetPasswordFocus = ()=>{
  data.resetPasswordTip=''
  data.resetPasswordTipIconShow=false
}*/
const verifyForm = Util.verifyForm
const nextStep = async()=>{//点击下一步
  if(!verifyForm({form:data.form,label:data.label})){
    reloadCode()
    return
  }
  if(data.isRequest)return
  data.isRequest = true
  var result = await ResetPassword.sendCode(data.form)
  data.isRequest = false
  if(Util.isNull(result)){
    reloadCode()
    return
  }
  if (result.code != 0) {
    Element.message({message:result.message,type:"error"})
    reloadCode()
    return
  }
  Element.message({message:msg['jsLang.sendEmailCode']})
  data.lType = '1'
}
const reset = async()=>{
  if(!verifyForm({form:data.resetPasswordForm,label:data.resetPasswordLabel})) return
  let result = await ResetPassword.reset({
    account:data.form.email,
    password:data.resetPasswordForm.password,
    token:data.resetPasswordForm.token
  })
  if(Util.isNull(result))return
  if(result.code!=0){
    Element.message({message:result.message,type:"error"})
    return
  }
  Element.message({message:msg["jsLang.resetPasswordSuccess"]})
  setTimeout(()=>{
    Router.push({path:"/login"})
  },2000)
}
const setAppHeight = ()=>{
  if(window.innerWidth>767)return
  data.loginHeight = window.innerHeight+'px'//获取当前可视区域的高度存到hrt变量
}
const initParams=()=>{
  let {lType} = Router.getQuery()
  if(typeof lType !== "undefined"){
    data.lType = lType
  }
}
initParams()
setAppHeight()

return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(pullRefresh, {
    onRefresh: _unref(pullRefreshJs).pullDownRefresh
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "login",
        style: _normalizeStyle('background-image:url('+_unref(CONFIG).BASE_STATIC_URL+'user/resetPassword/bg.jpg);'+(data.loginHeight!==''?('height:'+data.loginHeight):''))
      }, [
        _withDirectives(_createElementVNode("div", _hoisted_1, [
          _createElementVNode("a", {
            class: "logo",
            href: _unref(CONFIG).BASE_URL
          }, [
            _createElementVNode("img", {
              class: "logo-img",
              src: _unref(CONFIG).BASE_STATIC_URL+'user/resetPassword/logo.png'
            }, null, 8, _hoisted_3)
          ], 8, _hoisted_2),
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("input", {
                  class: "login-form-left-input",
                  type: "text",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((data.form.email) = $event)),
                  placeholder: data.label.email.name
                }, null, 8, _hoisted_9), [
                  [_vModelText, data.form.email]
                ]),
                _createElementVNode("img", {
                  class: "login-form-left-icon2 wap-reload-img",
                  src: _unref(CONFIG).BASE_STATIC_URL+'user/login/icon-delete.png',
                  onClick: _cache[1] || (_cache[1] = $event => (data.form.email=''))
                }, null, 8, _hoisted_10)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _withDirectives(_createElementVNode("input", {
                  class: "login-form-left-input",
                  type: "text",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((data.form.captcha) = $event)),
                  placeholder: data.label.captcha.name
                }, null, 8, _hoisted_13), [
                  [_vModelText, data.form.captcha]
                ]),
                _createElementVNode("img", {
                  class: "login-form-left-icon2 wap-reload-img",
                  src: _unref(CONFIG).BASE_STATIC_URL+'user/login/icon-delete.png',
                  onClick: _cache[3] || (_cache[3] = $event => (data.form.captcha=''))
                }, null, 8, _hoisted_14)
              ]),
              _withDirectives(_createElementVNode("img", {
                class: "login-form-right",
                src: data.codeUrl,
                onClick: _cache[4] || (_cache[4] = $event => (reloadCode()))
              }, null, 8, _hoisted_15), [
                [_vShow, data.codeUrl]
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: "login-button",
            onClick: _cache[5] || (_cache[5] = $event => (nextStep()))
          }, "下一步")
        ], 512), [
          [_vShow, data.lType==='0']
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_16, [
          _createElementVNode("a", {
            class: "logo",
            href: _unref(CONFIG).BASE_URL
          }, [
            _createElementVNode("img", {
              class: "logo-img",
              src: _unref(CONFIG).BASE_STATIC_URL+'user/resetPassword/logo.png'
            }, null, 8, _hoisted_18)
          ], 8, _hoisted_17),
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _withDirectives(_createElementVNode("input", {
                  class: "login-form-left-input",
                  onBlur: _cache[6] || (_cache[6] = $event => (formInputBlur({form:'resetPasswordForm',key:'token',label:'resetPasswordLabel'}))),
                  onFocus: _cache[7] || (_cache[7] = $event => (data.resetPasswordLabel.token.tip='')),
                  type: "text",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((data.resetPasswordForm.token) = $event)),
                  placeholder: data.resetPasswordLabel.token.name
                }, null, 40, _hoisted_23), [
                  [_vModelText, data.resetPasswordForm.token]
                ]),
                _withDirectives(_createElementVNode("img", {
                  class: "login-form-left-icon2 wap-reload-img",
                  src: _unref(CONFIG).BASE_STATIC_URL+'user/login/icon-delete.png',
                  onClick: _cache[9] || (_cache[9] = $event => (data.resetPasswordForm.token=''))
                }, null, 8, _hoisted_24), [
                  [_vShow, !data.resetPasswordLabel.token.tip]
                ]),
                _withDirectives(_createElementVNode("img", {
                  class: "login-form-left-icon2 cursor-default",
                  src: _unref(CONFIG).BASE_STATIC_URL+'user/resetPassword/'+(data.resetPasswordLabel.token.tip==='SUCCESS'?'great':'error')+'.png'
                }, null, 8, _hoisted_25), [
                  [_vShow, data.resetPasswordLabel.token.tip]
                ])
              ]),
              _withDirectives(_createElementVNode("div", { class: "login-form-tip" }, _toDisplayString(data.resetPasswordLabel.token.tip), 513), [
                [_vShow, data.resetPasswordLabel.token.tip&&data.resetPasswordLabel.token.tip!='SUCCESS']
              ])
            ]),
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("div", _hoisted_27, [
                _withDirectives(_createElementVNode("input", {
                  class: "login-form-left-input",
                  onFocus: _cache[10] || (_cache[10] = $event => (data.resetPasswordLabel.password.tip='')),
                  onBlur: _cache[11] || (_cache[11] = $event => (formInputBlur({form:'resetPasswordForm',key:'password',label:'resetPasswordLabel'}))),
                  type: data.resetPasswordLabel.password.showPassword?'text':'password',
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((data.resetPasswordForm.password) = $event)),
                  placeholder: data.resetPasswordLabel.password.name
                }, null, 40, _hoisted_28), [
                  [_vModelDynamic, data.resetPasswordForm.password]
                ]),
                _withDirectives(_createElementVNode("img", {
                  class: "login-form-left-icon2 login-form-left-icon3 wap-reload-img",
                  src: _unref(CONFIG).BASE_STATIC_URL+'user/login/icon-password-'+(data.resetPasswordLabel.password.showPassword?'hide':'show')+'.png',
                  onClick: _cache[13] || (_cache[13] = $event => (data.resetPasswordLabel.password.showPassword=!data.resetPasswordLabel.password.showPassword))
                }, null, 8, _hoisted_29), [
                  [_vShow, !data.resetPasswordLabel.password.tip]
                ]),
                _withDirectives(_createElementVNode("img", {
                  class: "login-form-left-icon2 cursor-default",
                  src: _unref(CONFIG).BASE_STATIC_URL+'user/resetPassword/'+(data.resetPasswordLabel.password.tip==='SUCCESS'?'great':'error')+'.png'
                }, null, 8, _hoisted_30), [
                  [_vShow, data.resetPasswordLabel.password.tip]
                ])
              ]),
              _withDirectives(_createElementVNode("div", { class: "login-form-tip" }, _toDisplayString(data.resetPasswordLabel.password.tip), 513), [
                [_vShow, data.resetPasswordLabel.password.tip&&data.resetPasswordLabel.password.tip!='SUCCESS']
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("div", _hoisted_32, [
                _withDirectives(_createElementVNode("input", {
                  class: "login-form-left-input",
                  onFocus: _cache[14] || (_cache[14] = $event => (data.resetPasswordLabel.passwords.tip='')),
                  onBlur: _cache[15] || (_cache[15] = $event => (formInputBlur({form:'resetPasswordForm',key:'passwords',label:'resetPasswordLabel'}))),
                  type: data.resetPasswordLabel.passwords.showPassword?'text':'password',
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => ((data.resetPasswordForm.passwords) = $event)),
                  placeholder: data.resetPasswordLabel.passwords.name
                }, null, 40, _hoisted_33), [
                  [_vModelDynamic, data.resetPasswordForm.passwords]
                ]),
                _withDirectives(_createElementVNode("img", {
                  class: "login-form-left-icon2 login-form-left-icon3 wap-reload-img",
                  src: _unref(CONFIG).BASE_STATIC_URL+'user/login/icon-password-'+(data.resetPasswordLabel.passwords.showPassword?'hide':'show')+'.png',
                  onClick: _cache[17] || (_cache[17] = $event => (data.resetPasswordLabel.passwords.showPassword=!data.resetPasswordLabel.passwords.showPassword))
                }, null, 8, _hoisted_34), [
                  [_vShow, !data.resetPasswordLabel.passwords.tip]
                ]),
                _withDirectives(_createElementVNode("img", {
                  class: "login-form-left-icon2 cursor-default",
                  src: _unref(CONFIG).BASE_STATIC_URL+'user/resetPassword/'+(data.resetPasswordLabel.passwords.tip==='SUCCESS'?'great':'error')+'.png'
                }, null, 8, _hoisted_35), [
                  [_vShow, data.resetPasswordLabel.passwords.tip]
                ])
              ]),
              _withDirectives(_createElementVNode("div", { class: "login-form-tip" }, _toDisplayString(data.resetPasswordLabel.passwords.tip), 513), [
                [_vShow, data.resetPasswordLabel.passwords.tip&&data.resetPasswordLabel.passwords.tip!='SUCCESS']
              ])
            ])
          ]),
          _createElementVNode("div", {
            class: "login-button",
            onClick: _cache[18] || (_cache[18] = $event => (reset()))
          }, "確認更改")
        ], 512), [
          [_vShow, data.lType==='1']
        ])
      ], 4)
    ]),
    _: 1
  }, 8, ["onRefresh"]))
}
}

}